import React from 'react'
import { Trans } from '@lingui/macro'

import { CertificationEnrolmentStatusEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { CertificationEnrolmentCard } from '../../../certifications-page/components/CertificationEnrolmentCard'
import { linkBuilder, staticLinks } from '../../../../../../shared/linkBuilder'
import { useAssignedCertificationsQuery } from './YourCertifications.codegen'
import { brandColors } from 'shared/basicPalette'
import { Box, Flex, FlexBoxGrid, LinkOverlay } from 'front-end/src/components'

export const YourCertifications = () => {
  const { data } = useAssignedCertificationsQuery()

  if (!data || !data.me.certificationEnrolments.length) {
    return null
  }

  return (
    <Box className="YourCertifications">
      <Flex className="grid-header" alignItems="center">
        <h3>
          <Trans>Your certifications</Trans>
        </h3>
        <LinkOverlay
          className="view-all"
          to={staticLinks.certifications}
          marginLeft="24px"
          color={brandColors.grey.mid}
          transform="translateY(2px)"
        >
          <Trans>View all</Trans>
        </LinkOverlay>
      </Flex>

      <FlexBoxGrid
        className="Page__content"
        columns={['100%', '100%', '100%', '40%']}
        flexWrap="wrap"
        columnGap="32px"
        rowGap="24px"
        mb="56px"
      >
        {[
          CertificationEnrolmentStatusEnum.EXPIRED,
          CertificationEnrolmentStatusEnum.NOT_STARTED,
          CertificationEnrolmentStatusEnum.OVERDUE,
          CertificationEnrolmentStatusEnum.IN_PROGRESS
        ].map((statusToRender) => {
          return data.me.certificationEnrolments
            .filter((cert) => cert.status === statusToRender)
            .map((certificationEnrolment) => (
              <Box key={certificationEnrolment.id}>
                <LinkOverlay
                  display="flex"
                  flexGrow={1}
                  to={linkBuilder.certificationsDetail(
                    certificationEnrolment.certification.id
                  )}
                >
                  <CertificationEnrolmentCard
                    certificationEnrolment={certificationEnrolment}
                    small
                  />
                </LinkOverlay>
              </Box>
            ))
        })}
      </FlexBoxGrid>
    </Box>
  )
}
